//package Import
import React, { useEffect, useState, useRef } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { getPresignedUrl } from "../../services/apiServices/PostServices";
import { approveSellShare,rejectApproval } from "../../services/apiServices/PostServices";


//component import
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { ImageUtils } from "../imageUtils/ImageUtils";
import CustomModal from "./CustomModal";
import FileUpload from "./FileUpload";
import Loader from "../../components/loadingScreens/Loader";
import { showToast } from "../constants/Toaster";

const DetailedViewSellShares = (props) => {
    const { close, open,data ,valueDetails,userId,currentShare,totalShares} = props;
    const [show, setShow] = useState(false);
    const [shareQuantity,setshareQuantity]=useState("")
    const [rejectModal,setRejectModal]=useState(false)
    const [fileval,setFileVal]=useState("")
    const [fileSize,setFileSize]=useState(0)
    const [deleteModal,setDeleteModal]=useState(false)
    const handleDeleteModal = () => setDeleteModal(false)
    const [fileUploadReqbody,setFileUploadReqbody]=useState()
    const [approvalConfirmModal,setApprovalConfirmModal]=useState(false)
    const [modalBlur, setModalBlur] = useState(false)
    const [fileData,setFileData]=useState()
    const [file,setFile]=useState()
    const [previewFile,setPreviewFile]=useState()
    const [shareAmount,setShareAmout]=useState(0)
    const [isLoader,setIsLoader]=useState(false)
    const modalRef = useRef();
    //function for handle modal backDrop Click
    const handleBackdropClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            // Handle the click outside the modal (e.g., prevent closing the modal)
            e.preventDefault();
            e.stopPropagation();
        }
    };

    useEffect(() => {
        if (data !== undefined) {
          callSellAmount()
        }
        setFileVal("")
      }, [data]);

//function call to calculate the sell amount
      const callSellAmount = () => {
        let amountValue = handleNoOfshares(data?.sell_shares,data?.share_value)
        setShareAmout(amountValue)
      }

      //function call to handle sell request approval
    const handleApproveSellShare =  async(url) => {
        let amount = shareAmount
        if(amount !== undefined){
            setIsLoader(true)
            const reqBody = {
                share_id: data?.id,
                user_id: userId,
                image_url: url,
                sell_amount : amount
             }
            
        const res = await approveSellShare(`sellShares`, reqBody);  
        if (res?.success) {
            showToast(1,res?.message)
            setModalBlur(false)
            setApprovalConfirmModal(false) 
            setshareQuantity("")
            close()
        } else {
            //showToast(3,res?.message)
            console.log("res", res?.message)
        }
        }
        else{
            console.log("error amount undefined")
        }
    }

   //function call to handle sell request by checking image file uploading
    const handleApproveSellRequest = async () => {
        // if(shareQuantity === ""){
        //     showToast(3,"Please enter shares for the approval")
        if (fileval === ""){
            showToast(3,"Please upload image")
        }
        if(fileSize > 5 * 1048576 ){
            showToast(3, "Image should be less than 5 mb")
        }
        else if(fileval !== "") {
            const resUrl = await getPresignedUrl("dataSignUrl", fileUploadReqbody)
            if (resUrl?.success) {
                ImageUtils.uploadFileToS3(fileData, true, resUrl?.data?.preSignedUrl)
                    .then(res => {
                        if(res?.ok){
                            setFile(resUrl?.data?.dataUrl)
                        }
                        handleApproveSellShare(resUrl?.data?.dataUrl)
                    })
                    .catch(e => {
                        console.log(e);
                    });
            } else {
                console.log("res", resUrl?.message)
            }
        }
    }

    const handleNoOfshares = (share,value) => {
        const totalSharesAlreadyPurchased = parseInt(totalShares); // Total shares already purchased
        const newSharesToBePurchased = parseInt(share); // New shares to be purchased
        
        // Calculate total cost
        const totalCost = newSharesToBePurchased * value;
        return totalCost
     }

    //function call to on change share share amount
    const hanldeShareAmont = (value) => {
        let val = parseInt(value)
        setShareAmout(val)
    }
   //function call to increase the amount
    const hadlePlusSign = () => {
        setShareAmout(shareAmount+1)
    }
  //function call to decrease the amount
    const hadleMinusSign = () => [
        setShareAmout(shareAmount-1)
    ]
    
    //function to handle modal open and close
    const handleShow = () => {
        setModalBlur(true)
        setShow(true);
    }

    const handleClose = () => {
        setModalBlur(false)
        setShow(false)
    }

    //function call to delete modal
    const hanldeDeleteOpen = () => {
        setDeleteModal(true)
    }

    //function to delete image
    const handleImageDelte = () => {
        setFileVal("")
        setFileSize(0)
        setFile()
        setDeleteModal(false)
     } 

   
    //function call to open reject modal
    const handleRejectOpen = () => {
        setRejectModal(true)
    }
    //function api call to reject the approval
    const handleRejectAction = async (val) => {
     const message = val
     
     if(message === ""){
      showToast(3,"Please enter reason in the reason field")
     }else{
        setIsLoader(true)
      const reqBody = {
        user_id:props?.userId,
      share_id:props?.data?.id,
      message:message
       }

       const res = await rejectApproval(`reject`, reqBody);       
          if (res?.success) {
              showToast(1,res?.message)
              handleCloseReject()
              close()
          } else {
             // showToast(3,res?.message)
              console.log("res", res?.message)
          }
     }
    }
    //function call to close the reject modal
    const handleCloseReject = () => {
      setRejectModal(false)
    }
    //function call to close the approval modal
    const handleCloseApprove = () => {
        setApprovalConfirmModal(false)
        setModalBlur(false)
      }

      const handleApproveRequest = () => {
        if (fileval === ""){
            showToast(3,"Please upload image")
        }else{
            setApprovalConfirmModal(true)
            setModalBlur(true)
        }
      }

    //function to handle image uploading file
    const handleImageUpload =  async (data) => {
        setFileVal(data?.name)
        setFileSize(data?.size)
        // setFile(URL.createObjectURL(data))
        setPreviewFile(URL.createObjectURL(data))

        if (data?.size <= 5 * 1048576) {
          
            const reqBody = {
                fileName: data?.name,
                mediaType: data?.type,
                dataType: "shares",
                serviceType:"sell"
            };

            setFileUploadReqbody(reqBody)
            setFileData(data)

            
        } else {
            showToast(3, "Image should be less than 5 mb")
        }
      }

    const handleOnclose = () => {
        setshareQuantity("")
        setFileVal("")
       close()
    }

   
    return (
        <>
        <Modal show={open} onHide={handleOnclose} aria-labelledby="contained-modal-title-vcenter"
            centered size={"md"} backdrop="static" data-bs-theme="dark" onClick={handleBackdropClick} >
            <div class={modalBlur ?"blurBackground": ""}>
                {/* {isLoader ? <Loader/> :null} */}
                <Modal.Header style={{ backgroundColor: "#0A2FB6"}} closeButton>
                    <h6 class="text-white fw-bold m-0 montserrat" >Detail View - Sell Request</h6>
                </Modal.Header>
                <div class="d-flex flex-column w-100 justify-content-center align-items-center mx-4">
                    <div class="d-flex flex-column align-self-start mx-2 w-100 my-2">
                        <div class="d-flex w-75">
                        <h6 class="subHeading w-50 roboto">Requested Shares </h6>
                        <h6 class="mx-4 w-50 m-0 status-pending fw-normal"> :  {data?.sell_shares}</h6>
                        </div>
                        <div class="d-flex w-75">
                        <h6 class="subHeading w-50 roboto">Share Name </h6>
                        <h6 class="mx-4 w-50 m-0 status-pending fw-normal"> :  {data?.share_name}</h6>
                        </div>
                        <div class="d-flex w-75">
                        <h6 class="subHeading w-50 roboto">Share Value</h6>
                        <h6 class="mx-4 w-50 m-0 status-pending fw-normal"> :  {data?.share_value}</h6>
                        </div>
                        <div class="d-flex w-75">
                        <h6 class="subHeading w-50 roboto">Approx. amount</h6>
                        <h6 class="mx-4 w-50 m-0 status-pending fw-normal"> : ₹{handleNoOfshares(data?.sell_shares,data?.share_value)}</h6>
                        </div>
                        <div class="d-flex w-75">
                        <h6 class="subHeading my-2 w-50 roboto">Message</h6>
                        <h6 class="status-pending  mt-2 w-50 my-2 roboto">: {data?.message === undefined ?  "-" : data?.message} </h6>
                        </div>
                    </div>
                </div>
                <div class="p-4 pb-0">
                <div class="d-flex flex-column   border w-100 my-2">
                        <div class="d-flex  justify-content-between border-bottom p-1 flex-row ">
                            <div class="w-50">
                            <h6>Shares Quantities</h6>
                            </div>
                             <div class="w-25 me-3 text-start" >
                            {data?.sell_shares}
                             </div>
                             
                        </div>
                        <div class="d-flex  justify-content-between border-bottom p-1 flex-row ">
                            <div class="w-50">
                            <h6>Approx.Amount </h6>
                            </div>
                             <div class="w-50 text-end" >
                             {/* <h6>₹{handleNoOfshares(data?.sell_shares)}</h6> */}
                             <i class="bi bi-dash  " onClick={() => hadleMinusSign()}></i>
                <input value={shareAmount}
                  type="Number"
                  onChange={(e) => {
                    hanldeShareAmont(e.target.value)
                  }}
                  class="amountStyle shadow"
                />
                <i class="bi bi-plus cursorPointer" onClick={() => hadlePlusSign()}></i>
                             </div>
                        </div>
                        <div class="d-flex  justify-content-between align-items-center border-bottom p-1 flex-row">
                            <div class="text-center">
                            <h6 class="m-0">Upload Image</h6>
                            </div>
                             <div class="mx-2" >
                             <div class="d-flex flex-row w-100 justify-content-center align-items-center" >
                              {fileval === "" ? <FileUpload onClick={handleImageUpload}  id={"img"} name={"img"} /> : null }
                                {fileval != "" ?
                                <div class="d-flex flex-row" >
                                 <h6 class="mx-2 paraColor">{fileval}</h6> 
                                 <h6 class=" previewColor text-end mx-2 cursorPointer" onClick={handleShow} >Preview</h6>
                                 <i class="bi bi-trash" onClick={() => hanldeDeleteOpen()}></i>
                                 </div>
                                 : 
                                 ""
                                 }
                             </div>
                             </div>
                        </div>
                     </div>
                     <div class="d-flex flex-column w-100">
                     <div class="d-flex  my-1 align-self-center mb-2">
                            <button class={parseInt(currentShare)< data?.sell_shares ? "disabledButton px-3 mx-2" :"primaryButton  px-3 mx-2"} onClick={() => handleApproveRequest()} disabled={parseInt(currentShare)< data?.sell_shares ? true : false} >
                            Approve
                            </button>
                            <button class="primaryButton px-4 mx-2 " onClick={() => handleRejectOpen()}  >
                                Reject
                            </button>
                        </div>
                     </div>
                </div>
                <CustomModal 
                      close={handleDeleteModal}
                      open={deleteModal}
                      Action ={handleImageDelte}
                      modalContent={"Are you sure want to delete the image?"}
                     />
                     <CustomModal 
                      close={handleClose}
                      open={show}
                      imgvalue={previewFile}
                     />
            </div>
        </Modal>
         <CustomModal 
         close={handleCloseReject}
         open={rejectModal}
         RejectAction ={handleRejectAction}
         modalContent={"Are you sure want to reject the approval?"}
        />
        <CustomModal
          close={handleCloseApprove}
          open={approvalConfirmModal}
          Action={handleApproveSellRequest}
          type={"approval"}
          modalContent={"Are you sure want to approval the sell request?"}
        />
        </>
    )
}

export default DetailedViewSellShares